import React, { useEffect, useState } from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Input,
  Textarea,
} from "@chakra-ui/react";
import Editor from "../editor/Editor";

const MainPanel = ({
  mainLang,
  changeLang,
  languageInfo,
  descriptionShow = false,
}) => {
  const [id, setId] = useState(0);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [lang, setLang] = useState("");
  const [seoTitle, setSeoTitle] = useState("");
  const [seoDescription, setSeoDescription] = useState("");
  useEffect(() => {
    changeLang({ id, name, description, lang, seoTitle, seoDescription });
  }, [id, name, description, lang, seoTitle, seoDescription]);
  return (
    <>
      <Tabs variant="enclosed">
        <TabList>
          {mainLang && mainLang.map((l) => (
            <Tab key={l.id}>{l.langKey}</Tab>
          ))}
        </TabList>
        <TabPanels>
          {
            mainLang?.map((x) => (
              <TabPanel key={x.id}>
                <div className="">
                  <label>Title</label>
                  <Input
                    mb={3}
                    type="text"
                    required
                    value={languageInfo.find((l) => l.languageKey === x.langKey)?.name || ""}
                    onChange={(e) => {
                      const newName = e.target.value;
                      setName(newName);
                      setLang(x.langKey);
                      const updatedLangInfo = languageInfo.find((l) => l.languageKey === x.langKey);
                      setId(updatedLangInfo?.id);
                      setSeoDescription(languageInfo.find((l) => l.languageKey === x.langKey)?.seoDescription)
                      setSeoTitle(languageInfo.find((l) => l.languageKey === x.langKey)?.seoTitle)
                      setDescription(languageInfo.find((l) => l.languageKey === x.langKey)?.description)
                    }}
                  />

                  {!descriptionShow && (
                    <div
                      style={{ marginBottom: '16px' }}
                    >
                      <label>Description</label>
                      <Editor
                        value={languageInfo.find((l) => l.languageKey === x.langKey)}
                        setDescriptionHandle={setDescription}
                        setIdHandle={setId}
                        setLangHandle={setLang}
                        setNameHandle={setName}
                        setSeoTitleHandle={setSeoTitle}
                        setSeoDesHandle={setSeoDescription}
                      />
                    </div>
                  )}

                  {/* SeoTitle */}
                  <div>
                    <label>SEO Title</label>
                    <Input
                      mb={3}
                      type="text"
                      value={languageInfo.find((l) => l.languageKey === x.langKey)?.seoTitle || ""}
                      onChange={(e) => {
                        const newName = e.target.value;
                        setSeoTitle(newName);
                        setLang(x.langKey);
                        const updatedLangInfo = languageInfo.find((l) => l.languageKey === x.langKey);
                        setId(updatedLangInfo?.id);
                        setSeoDescription(languageInfo.find((l) => l.languageKey === x.langKey)?.seoDescription)
                        setName(languageInfo.find((l) => l.languageKey === x.langKey)?.name)
                        setDescription(languageInfo.find((l) => l.languageKey === x.langKey)?.description)
                      }}
                    />
                  </div>

                  {/* SeoDescription */}
                  <div>
                    <label>SEO Description</label>
                    <Textarea
                      mb={3}
                      type="text"
                      value={languageInfo.find((l) => l.languageKey === x.langKey)?.seoDescription || ""}
                      onChange={(e) => {
                        const newName = e.target.value;
                        setSeoDescription(newName);
                        setLang(x.langKey);
                        const updatedLangInfo = languageInfo.find((l) => l.languageKey === x.langKey);
                        setId(updatedLangInfo?.id);
                        setSeoTitle(languageInfo.find((l) => l.languageKey === x.langKey)?.seoTitle)
                        setName(languageInfo.find((l) => l.languageKey === x.langKey)?.name)
                        setDescription(languageInfo.find((l) => l.languageKey === x.langKey)?.description)
                      }}
                    />
                  </div>
                </div>
              </TabPanel>
            ))}
        </TabPanels>
      </Tabs>
    </>
  );
};

export default React.memo(MainPanel);
